import React, { useEffect, useState } from 'react';
import { fetchPublicProfile } from '../Api/PublicApi';
import { getTemplate } from '../Data/templates';
import TemplatePreview from '../Components/TemplatePreview';
import '../Style/PublicProfile.css';

export default function PublicProfile({ username }) {
  const [profile, setProfile] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let off = false;
    (async () => {
      try {
        const p = await fetchPublicProfile(username);
        if (!off) setProfile(p);
      } catch {
        if (!off) setNotFound(true);
      } finally {
        if (!off) setLoading(false);
      }
    })();
    return () => {
      off = true;
    };
  }, [username]);

  if (loading) {
    return (
      <div className="pub">
        <p className="pub__msg">Loading…</p>
      </div>
    );
  }

  if (notFound || !profile) {
    return (
      <div className="pub">
        <div className="pub__notfound">
          <p className="pub__notfound-title">This page isn&rsquo;t available</p>
          <p className="pub__notfound-text">
            The link may be incorrect, or this page hasn&rsquo;t been published yet.
          </p>
        </div>
      </div>
    );
  }

  const template = getTemplate(profile.template_id) || getTemplate('other-01');

  return (
    <div className="pub">
      <div className="pub__phone">
        <TemplatePreview template={template} profile={profile} customization={profile.customization} live />
      </div>
    </div>
  );
}